import React, { useState, useRef, useEffect } from "react";
import "./css/create_job.css";
import { useNavigate } from "react-router-dom";
import {  jobsEndpoint } from '../constants';

const CreateJob = () => {
  const navigate = useNavigate();
  
  // Complete regions array with all 87 regions from your XML data
  const regions = [
    { value: '68', label: 'Non UK' },
    { value: '69', label: 'Channel Islands' },
    { value: '70', label: 'Alderney' },
    { value: '71', label: 'Guernsey' },
    { value: '72', label: 'Jersey' },
    { value: '73', label: 'East Anglia' },
    { value: '74', label: 'Cambridgeshire' },
    { value: '75', label: 'Norfolk' },
    { value: '76', label: 'Suffolk' },
    { value: '77', label: 'East Midlands' },
    { value: '78', label: 'Derbyshire' },
    { value: '79', label: 'Leicestershire' },
    { value: '80', label: 'Lincolnshire' },
    { value: '81', label: 'Northamptonshire' },
    { value: '82', label: 'Nottinghamshire' },
    { value: '83', label: 'Isle of Man' },
    { value: '84', label: 'North' },
    { value: '85', label: 'Cleveland' },
    { value: '86', label: 'Cumbria' },
    { value: '87', label: 'Durham' },
    { value: '88', label: 'Northumberland' },
    { value: '89', label: 'Tyne and Wear' },
    { value: '90', label: 'North East' },
    { value: '91', label: 'Humberside' },
    { value: '92', label: 'North Yorkshire' },
    { value: '93', label: 'South Yorkshire' },
    { value: '94', label: 'West Yorkshire' },
    { value: '95', label: 'North West' },
    { value: '96', label: 'Cheshire' },
    { value: '97', label: 'Greater Manchester' },
    { value: '98', label: 'Lancashire' },
    { value: '99', label: 'Merseyside' },
    { value: '100', label: 'Northern Ireland' },
    { value: '101', label: 'Antrim' },
    { value: '102', label: 'Armagh' },
    { value: '103', label: 'Down' },
    { value: '104', label: 'Fermanagh' },
    { value: '105', label: 'Londonderry' },
    { value: '106', label: 'Tyrone' },
    { value: '107', label: 'Scotland' },
    { value: '108', label: 'Borders' },
    { value: '109', label: 'Central Scotland' },
    { value: '110', label: 'Dumfries & Galloway' },
    { value: '111', label: 'Fife' },
    { value: '112', label: 'Grampian' },
    { value: '113', label: 'Highlands & Islands' },
    { value: '114', label: 'Lothian' },
    { value: '115', label: 'Strathclyde' },
    { value: '116', label: 'Tayside' },
    { value: '117', label: 'South East' },
    { value: '118', label: 'Bedfordshire' },
    { value: '119', label: 'Berkshire' },
    { value: '120', label: 'Buckinghamshire' },
    { value: '121', label: 'East Sussex' },
    { value: '122', label: 'Essex' },
    { value: '123', label: 'Hampshire' },
    { value: '124', label: 'Hertfordshire' },
    { value: '125', label: 'Isle of Wight' },
    { value: '126', label: 'Kent' },
    { value: '127', label: 'London' },
    { value: '128', label: 'Middlesex' },
    { value: '129', label: 'Oxfordshire' },
    { value: '130', label: 'Surrey' },
    { value: '131', label: 'West Sussex' },
    { value: '132', label: 'South West' },
    { value: '133', label: 'Avon' },
    { value: '134', label: 'Cornwall' },
    { value: '135', label: 'Devon' },
    { value: '136', label: 'Dorset' },
    { value: '137', label: 'Gloucestershire' },
    { value: '138', label: 'Somerset' },
    { value: '139', label: 'Wiltshire' },
    { value: '140', label: 'Wales' },
    { value: '141', label: 'Clwyd' },
    { value: '142', label: 'Dyfed' },
    { value: '143', label: 'Gwent' },
    { value: '144', label: 'Gwynedd' },
    { value: '145', label: 'Mid Glamorgan' },
    { value: '146', label: 'Powys' },
    { value: '147', label: 'South Glamorgan' },
    { value: '148', label: 'West Glamorgan' },
    { value: '149', label: 'West Midlands' },
    { value: '150', label: 'Birmingham' },
    { value: '151', label: 'Hereford & Worcestershire' },
    { value: '152', label: 'Shropshire' },
    { value: '153', label: 'Staffordshire' },
    { value: '154', label: 'Warwickshire' },
    { value: '411', label: 'UK' },
    { value: '412', label: 'Aberdeenshire' }
  ];

  // Complete form data state
  const [formData, setFormData] = useState({
    title: '',
    department: '',
    location: '',
    city: '',
    state: '',
    country: '',
    level: '',
    type: '',
    position: '',
    company: '',
    time: '',
    card_type: 'NORMAL',
    body: '',
    offer_text: '',
    requirements: '',
    category: '',
    offer_price: '',
    tags: '',
    quiet_mode: false,
    content: [],
    // Library fields
    employment_type_library: '',
    industry_library: '',
    salary_period_library: '',
    region_library: ''
  });

  // Employment types - updated to match library values
  const employmentTypes = [
    { value: 'permanent', label: 'Permanent' },
    { value: 'contract', label: 'Contract' },
    { value: 'temporary', label: 'Temporary' },
    { value: 'part_time', label: 'Part Time' },
    { value: 'apprenticeship', label: 'Apprenticeship' }
  ];

  // Complete industries array
  const industries = [
    { value: '1', label: 'Accounting/Financial/Insurance' },
    { value: '26', label: 'Administration' },
    { value: '2', label: 'Agriculture' },
    { value: '3', label: 'Arts/Graphic Design' },
    { value: '4', label: 'Automotive/Aerospace' },
    { value: '5', label: 'Catering' },
    { value: '6', label: 'Charity' },
    { value: '27', label: 'Construction' },
    { value: '8', label: 'Consulting' },
    { value: '9', label: 'Customer Services' },
    { value: '10', label: 'Distribution' },
    { value: '11', label: 'Education' },
    { value: '12', label: 'Electronics' },
    { value: '7', label: 'Engineering' },
    { value: '30', label: 'Hospitality/Hotel' },
    { value: '13', label: 'IT' },
    { value: '14', label: 'Legal' },
    { value: '15', label: 'Leisure/Tourism' },
    { value: '16', label: 'Management' },
    { value: '17', label: 'Manufacturing/Surveying' },
    { value: '29', label: 'Marketing' },
    { value: '19', label: 'Media' },
    { value: '20', label: 'Medical/Pharmaceutical/Scientific' },
    { value: '21', label: 'Military/Emergency/Government' },
    { value: '23', label: 'Personnel/Recruitment' },
    { value: '24', label: 'Property Services' },
    { value: '31', label: 'Public Sector' },
    { value: '28', label: 'Retail/Purchasing' },
    { value: '18', label: 'Sales' },
    { value: '32', label: 'Social Care' },
    { value: '25', label: 'Telecoms' },
    { value: '22', label: 'Other' }
  ];

  // Salary periods
  const salaryPeriods = [
    { value: '403', label: 'Per Annum' },
    { value: '404', label: 'Per Month' },
    { value: '405', label: 'Per Week' },
    { value: '406', label: 'Per Day' },
    { value: '407', label: 'Per Hour' }
  ];

  // Department-related states
  const [departments, setDepartments] = useState([
    "Engineering",
    "Marketing", 
    "Sales",
    "Human Resources",
    "Finance",
    "Operations"
  ]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredDepartments, setFilteredDepartments] = useState(departments);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  // Region dropdown states
  const [showRegionDropdown, setShowRegionDropdown] = useState(false);
  const [filteredRegions, setFilteredRegions] = useState(regions);
  const [regionSearchTerm, setRegionSearchTerm] = useState('');
  const regionInputRef = useRef(null);
  const regionDropdownRef = useRef(null);

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
      if (regionDropdownRef.current && !regionDropdownRef.current.contains(event.target)) {
        setShowRegionDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }

    // Auto-populate library field when main employment type changes
    if (name === 'type') {
      const employmentTypeMap = {
        'Full-time': 'permanent',
        'Part-time': 'part_time',
        'Contract': 'contract',
        'Freelance': 'contract',
        'Internship': 'temporary'
      };
      
      setFormData(prev => ({
        ...prev,
        employment_type_library: employmentTypeMap[value] || ''
      }));
    }

    // Auto-populate industry library when category changes
    if (name === 'department') {
      const selectedIndustry = industries.find(industry => 
        industry.label.toLowerCase().includes(value.toLowerCase())
      );
      
      if (selectedIndustry) {
        setFormData(prev => ({
          ...prev,
          industry_library: selectedIndustry.value
        }));
      }
    }
  };

  // Handle department input changes
  const handleDepartmentInputChange = (e) => {
    const value = e.target.value;
    setFormData(prev => ({ ...prev, department: value }));
    
    // Filter departments based on input
    const filtered = departments.filter(dept => 
      dept.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredDepartments(filtered);
    setShowDropdown(true);
    
    // Clear error when user starts typing
    if (errors.department) {
      setErrors(prev => ({
        ...prev,
        department: ''
      }));
    }

    // Auto-populate industry library
    const selectedIndustry = industries.find(industry => 
      industry.label.toLowerCase().includes(value.toLowerCase())
    );
    
    if (selectedIndustry) {
      setFormData(prev => ({
        ...prev,
        industry_library: selectedIndustry.value
      }));
    }
  };

  // Handle department selection
  const handleDepartmentSelect = (dept) => {
    setFormData(prev => ({ ...prev, department: dept }));
    setShowDropdown(false);
    
    // Auto-populate industry library
    const selectedIndustry = industries.find(industry => 
      industry.label.toLowerCase().includes(dept.toLowerCase())
    );
    
    if (selectedIndustry) {
      setFormData(prev => ({
        ...prev,
        industry_library: selectedIndustry.value
      }));
    }
  };

  // Handle adding new department
  const handleAddNewDepartment = () => {
    const newDept = formData.department.trim();
    if (newDept && !departments.includes(newDept)) {
      setDepartments(prev => [...prev, newDept]);
      setShowDropdown(false);
    }
  };

  // Handle region search
  const handleRegionSearch = (e) => {
    const value = e.target.value;
    setRegionSearchTerm(value);
    
    // Update the actual state field
    setFormData(prev => ({ ...prev, state: value }));
    
    // Filter regions based on input
    const filtered = regions.filter(region => 
      region.label.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredRegions(filtered);
    setShowRegionDropdown(true);
    
    // Clear error when user starts typing
    if (errors.state) {
      setErrors(prev => ({
        ...prev,
        state: ''
      }));
    }
  };

  // Handle region selection
  const handleRegionSelect = (region) => {
    setFormData(prev => ({ 
      ...prev, 
      state: region.label,
      region_library: region.value
    }));
    setRegionSearchTerm(region.label);
    setShowRegionDropdown(false);
  };

  // Handle file uploads
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData(prev => ({
      ...prev,
      content: files
    }));

    // Clear any existing file errors
    if (errors.content) {
      setErrors(prev => ({
        ...prev,
        content: ''
      }));
    }
  };

  // Validation function
  const validateForm = () => {
    const newErrors = {};
    const validLevels = ['Entry Level', 'Mid Level', 'Senior Level', 'Executive'];
    const validEmploymentTypes = ['Full-time', 'Part-time', 'Contract', 'Freelance', 'Internship'];
    const validPositions = ['Open', 'Closed', 'Draft', 'On Hold'];
    const validLocations = ['Remote', 'On Site', 'Hybrid'];

    // Required field validation
    if (!formData.title.trim()) {
      newErrors.title = 'Job title is required';
    }
    
    if (!formData.department.trim()) {
      newErrors.department = 'Department is required';
    }

    // Add location validation
    if (!formData.location.trim()) {
      newErrors.location = 'Location type is required';
    } else if (!validLocations.includes(formData.location)) {
      newErrors.location = 'Invalid location type selected';
    }

    // Add city validation
    if (!formData.city.trim()) {
      newErrors.city = 'City is required';
    }

    // Add state validation
    if (!formData.state.trim()) {
      newErrors.state = 'County is required';
    }

    // Add country validation
    if (!formData.country.trim()) {
      newErrors.country = 'Country is required';
    }
    
    if (!formData.level.trim()) {
      newErrors.level = 'Experience level is required';
    } else if (!validLevels.includes(formData.level)) {
      newErrors.level = 'Invalid experience level';
    }
    
    if (!formData.type.trim()) {
      newErrors.type = 'Employment type is required';
    } else if (!validEmploymentTypes.includes(formData.type)) {
      newErrors.type = 'Invalid employment type';
    }

    if (!formData.position.trim()) {
      newErrors.position = 'Job status is required';
    } else if (!validPositions.includes(formData.position)) {
      newErrors.position = 'Invalid job status';
    }

    // Company validation (optional)
    if (formData.company.trim().length > 100) {
      newErrors.company = 'Company name must be less than 100 characters';
    }

    // Category validation (optional)
    if (formData.category.trim().length > 50) {
      newErrors.category = 'Category must be less than 50 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const token = localStorage.getItem('token');
      const submitFormData = new FormData();

      // Append all existing fields
      submitFormData.append('title', formData.title);
      submitFormData.append('department', formData.department);
      submitFormData.append('location', formData.location);
      submitFormData.append('city', formData.city);
      submitFormData.append('state', formData.state);
      submitFormData.append('country', formData.country);
      submitFormData.append('level', formData.level);
      submitFormData.append('type', formData.type);
      submitFormData.append('position', formData.position);
      submitFormData.append('company', formData.company);
      submitFormData.append('category', formData.category);
      
      // Add library fields (only if they have values)
      if (formData.employment_type_library) {
        submitFormData.append('employment_type_library', formData.employment_type_library);
      }
      if (formData.industry_library) {
        submitFormData.append('industry_library', formData.industry_library);
      }
      if (formData.salary_period_library) {
        submitFormData.append('salary_period_library', formData.salary_period_library);
      }
      if (formData.region_library) {
        submitFormData.append('region_library', formData.region_library);
      }
      
      // Add files if they exist
      if (formData.content && formData.content.length > 0) {
        formData.content.forEach((file, index) => {
          submitFormData.append(`content[${index}]`, file);
        });
      }

      const response = await fetch(`${jobsEndpoint}create/step1/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
        },
        body: submitFormData
      });
      
      console.log('Form data being sent:', Object.fromEntries(submitFormData));
      
      if (response.ok) {
        const result = await response.json();
        navigate("/job_description", { state: { jobId: result.id } });
      } else {
        if (response.status === 403) {
            const errorData = await response.json();
            if (errorData.error === 'limit_reached') {
                navigate('/limit-reached', { state: { resource: errorData.resource || 'active_jobs' } });
                return; // Stop further execution
            }
        }
        const errorData = await response.json();
        setErrors(errorData);
      }
    } catch (error) {
      console.error('Error creating job:', error);
      setErrors({ submit: 'An error occurred while creating the job' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full items-start pb-[8.625rem] lg:pr-[1.875rem] p-0">
      <div className="main_wrap flex flex-col items-start pt-[var(--spacing-md, 8px)]">
        <div className="main flex flex-col items-start gap-8 self-stretch pt-8 pb-12">
          <div className="flex flex-col items-start gap-6 self-stretch">
            <div className="container flex flex-col items-start self-stretch pb-[32px] pl-[var(--container-padding-desktop, 32px)] pr-[var(--container-padding-desktop, 32px)] pt-0 px-8">
              <div className="page_header flex flex-col items-start">
                <div className="flex flex-wrap items-start content-start">
                  <div className="text_and_supporting_text-2 flex flex-col items-start min-w-[20rem]">
                    <div className="self-stretch text-[#181d27] font-semibold">
                      Create Job
                    </div>
                    <div className="self-stretch text-[#535862] font-['var(--Font-family-font-family-body, Inter)'] text-[var(--Font-size-text-md, 16px)] leading-[var(--Line-height-text-md, 24px)]">
                      Here is a complete overview of your jobs.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Progress Steps */}
          <div className="flex flex-col items-center justify-center w-full">
            <div className="flex justify-center items-start w-full">
              <div className="_step_base flex flex-col items-center w-60">
                <div className="flex flex-col items-center self-stretch">
                  <div className="self-stretch text-[#009c97] lg:text-base text-sm text-center font-semibold">
                    Define your role
                  </div>
                  <div className="self-stretch text-[#009c97] text-center lg:text-base text-sm">
                  </div>
                </div>
                <div className="_step_icon_base flex justify-center items-center w-6 h-6 rounded-full bg-[#f9f5ff]">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#19BFB7" />
                    <circle cx={12} cy={12} r={4} fill="white" />
                  </svg>
                </div>
              </div>
              
              <div className="_step_base-1 flex flex-col items-center w-60">
                <div className="flex flex-col items-center self-stretch">
                  <div className="self-stretch text-[#414651] text-center font-semibold lg:text-base text-sm">
                    Job Description
                  </div>
                  <div className="self-stretch text-[#535862] text-center lg:text-base text-sm">
                  </div>
                </div>
                <div className="flex justify-center items-center w-6 h-6 rounded-full bg-neutral-50">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12Z" stroke="#E9EAEB" strokeWidth="1.5" />
                    <circle cx={12} cy={12} r={4} fill="#D5D7DA" />
                  </svg>
                </div>
              </div>
              
              <div className="_step_base-2 flex flex-col items-center w-60">
                <div className="flex flex-col items-center self-stretch">
                  <div className="self-stretch text-[#414651] text-center font-semibold lg:text-base text-sm">
                    Salary & Benefits
                  </div>
                  <div className="self-stretch text-[#535862] text-center lg:text-base text-sm">
                  </div>
                </div>
                <div className="flex justify-center items-center w-6 h-6 rounded-full bg-neutral-50">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12Z" stroke="#E9EAEB" strokeWidth="1.5" />
                    <circle cx={12} cy={12} r={4} fill="#D5D7DA" />
                  </svg>
                </div>
              </div>
              
              <div className="_step_base-3 flex flex-col items-center w-60">
                <div className="flex flex-col items-center self-stretch">
                  <div className="self-stretch text-[#414651] text-center font-semibold lg:text-base text-sm">
                    Hiring Preferences
                  </div>
                  <div className="self-stretch text-[#535862] text-center lg:text-base text-sm">
                  </div>
                </div>
                <div className="flex justify-center items-center w-6 h-6 rounded-full bg-neutral-50">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12Z" stroke="#E9EAEB" strokeWidth="1.5" />
                    <circle cx={12} cy={12} r={4} fill="#D5D7DA" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="flex items-start gap-6 w-full">
            <div className="flex flex-col items-start gap-10 pb-[32px] pt-0 px-8 w-full">
              <div className="flex lg:flex-row flex-col items-start lg:gap-6 gap-10 w-full">
                <div className="flex flex-col items-start gap-1 lg:w-[17.5rem] lg:min-w-[12.5rem] lg:max-w-[17.5rem]">
                  <div className="text_wrapper flex items-center">
                    <div className="text-[#414651] font-semibold leading-6">
                      Define the Role
                    </div>
                    <div className="text-[#009c97] text-[var(--Font-size-text-sm, 14px)] font-semibold">
                      *
                    </div>
                  </div>
                  <div className="self-stretch text-[#535862] text-[var(--Font-size-text-sm, 14px)]">
                    Tell us what you're hiring for, and we'll take care of the details!
                  </div>
                </div>
                
                <div className="w-full flex flex-col justify-center items-start gap-6">
                  {/* First Row - Job Title and Industry Category */}
                  <div className="flex items-center gap-6 self-stretch">
                    <div className="input_field flex flex-col items-start flex-1">
                      <div className="input_with_label-1 flex flex-col items-start self-stretch">
                        <div className="label_wrapper flex items-start">
                          <div className="text-[#414651] text-[var(--Font-size-text-sm, 14px)] font-medium">
                            Job Title
                          </div>
                          <div className="text-[#009c97] text-[var(--Font-size-text-sm, 14px)] font-medium">
                            *
                          </div>
                        </div>
                        <div className="input-1 flex items-center self-stretch py-2 px-3 rounded-lg border border-[#d5d7da] bg-white text-gray-700">
                          <input
                            type="text"
                            name="title"
                            placeholder="Enter your job title"
                            value={formData.title}
                            onChange={handleInputChange}
                            className="text-gray-700 w-full outline-none"
                          />
                        </div>
                        {errors.title && <span className="text-red-500 text-sm">{errors.title}</span>}
                      </div>
                    </div>
                    
                    <div className="input_field-1 flex flex-col items-start flex-1">
                      <div className="input_with_label-2 flex flex-col items-start self-stretch">
                        <div className="label_wrapper-1 flex items-start">
                          <div className="text-[#414651] font-medium">
                            Industry Category
                          </div>
                          <div className="text-[#009c97] font-medium">*</div>
                        </div>
                        <div className="input flex items-start self-stretch rounded-lg border border-[#d5d7da] bg-white">
                          <div className="text-gray-700 content flex items-center py-2 px-3 w-full">
                            <select
                              name="industry_library"
                              value={formData.industry_library}
                              onChange={handleInputChange}
                              className="w-full mr-3 outline-none"
                            >
                              <option value="">Choose industry</option>
                              {industries.map(industry => (
                                <option key={industry.value} value={industry.value}>{industry.label}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {errors.industry_library && <span className="text-red-500 text-sm">{errors.industry_library}</span>}
                      </div>
                    </div>
                  </div>

                  {/* Second Row - Department and Location Type */}
                  <div className="flex items-center gap-6 self-stretch">
                    <div className="input_field-1 flex flex-col items-start flex-1">
                      <div className="input_with_label-2 flex flex-col items-start self-stretch">
                        <div className="label_wrapper-1 flex items-start">
                          <div className="text-[#414651] font-medium">
                            Department
                          </div>
                          <div className="text-[#009c97] font-medium">*</div>
                        </div>
                        <div className="relative" ref={dropdownRef}>
                          <div className="input-2 flex items-start self-stretch rounded-lg border border-[#d5d7da] bg-white">
                            <div className="text-gray-700 content-21 flex items-center py-2 px-3 w-full">
                              <input
                                ref={inputRef}
                                type="text"
                                name="department"
                                value={formData.department}
                                onChange={handleDepartmentInputChange}
                                onFocus={() => setShowDropdown(true)}
                                placeholder="Enter department"
                                className="w-full mr-3 outline-none"
                                autoComplete="off"
                              />
                            </div>
                          </div>
                          
                          {/* Dropdown */}
                          {showDropdown && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-[#d5d7da] rounded-lg shadow-lg max-h-48 overflow-y-auto">
                              {filteredDepartments.length > 0 ? (
                                filteredDepartments.map((dept, index) => (
                                  <div
                                    key={index}
                                    onClick={() => handleDepartmentSelect(dept)}
                                    className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-gray-700"
                                  >
                                    {dept}
                                  </div>
                                ))
                              ) : (
                                formData.department.trim() && (
                                  <div
                                    onClick={handleAddNewDepartment}
                                    className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-[#009c97] font-medium"
                                  >
                                    + Add "{formData.department.trim()}"
                                  </div>
                                )
                              )}
                            </div>
                          )}
                        </div>
                        {errors.department && <span className="text-red-500 text-sm">{errors.department}</span>}
                      </div>
                    </div>
                    
                    <div className="input_field-2 flex flex-col items-start flex-1">
                      <div className="input_with_label-3 flex flex-col items-start self-stretch">
                        <div className="label_wrapper-2 flex items-start">
                          <div className="text-[#414651] font-medium">
                            Location Type
                          </div>
                          <div className="text-[#009c97] font-medium">*</div>
                        </div>
                        <div className="input-3 flex items-start self-stretch rounded-lg border border-[#d5d7da] bg-white">
                          <div className="text-gray-700 content flex items-center py-2 px-3 w-full">
                            <select
                              name="location"
                              value={formData.location}
                              onChange={handleInputChange}
                              className="w-full mr-3 outline-none"
                            >
                              <option value="">Choose location type</option>
                              <option value="Remote">Remote</option>
                              <option value="On Site">On Site</option>
                              <option value="Hybrid">Hybrid</option>
                              <option value="Relocation">Relocation</option>

                            </select>
                          </div>
                        </div>
                        {errors.location && <span className="text-red-500 text-sm">{errors.location}</span>}
                      </div>
                    </div>
                  </div>

                  {/* Third Row - City and County (with Region Search) */}
                  <div className="flex items-center gap-6 self-stretch">
                    <div className="input_field flex flex-col items-start flex-1">
                      <div className="input_with_label flex flex-col items-start self-stretch">
                        <div className="label_wrapper flex items-start">
                          <div className="text-[#414651] font-medium">
                            City
                          </div>
                          <div className="text-[#009c97] font-medium">*</div>
                        </div>
                        <div className="text-gray-700 input flex items-center self-stretch py-2 px-3 rounded-lg border border-[#d5d7da] bg-white">
                          <input
                            type="text"
                            name="city"
                            placeholder="Enter city"
                            value={formData.city}
                            onChange={handleInputChange}
                            className="text-gray-700 w-full outline-none"
                          />
                        </div>
                        {errors.city && <span className="text-red-500 text-sm">{errors.city}</span>}
                      </div>
                    </div>
                    
                    <div className="input_field flex flex-col items-start flex-1">
                      <div className="input_with_label flex flex-col items-start self-stretch">
                        <div className="label_wrapper flex items-start">
                          <div className="text-[#414651] font-medium">
                            County/Region
                          </div>
                          <div className="text-[#009c97] font-medium">*</div>
                        </div>
                        <div className="relative" ref={regionDropdownRef}>
                          <div className="text-gray-700 input flex items-center self-stretch py-2 px-3 rounded-lg border border-[#d5d7da] bg-white">
                            <input
                              ref={regionInputRef}
                              type="text"
                              name="state"
                              placeholder="Search county/region"
                              value={formData.state}
                              onChange={handleRegionSearch}
                              onFocus={() => setShowRegionDropdown(true)}
                              className="text-gray-700 w-full outline-none"
                              autoComplete="off"
                            />
                          </div>
                          
                          {/* Region Dropdown */}
                          {showRegionDropdown && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-[#d5d7da] rounded-lg shadow-lg max-h-48 overflow-y-auto">
                              {filteredRegions.length > 0 ? (
                                filteredRegions.map((region) => (
                                  <div
                                    key={region.value}
                                    onClick={() => handleRegionSelect(region)}
                                    className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-gray-700"
                                  >
                                    {region.label}
                                  </div>
                                ))
                              ) : (
                                <div className="px-3 py-2 text-gray-500">
                                  No regions found
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        {errors.state && <span className="text-red-500 text-sm">{errors.state}</span>}
                      </div>
                    </div>
                  </div>

                  {/* Fourth Row - Country and Experience Level */}
                  <div className="flex items-center gap-6 self-stretch">
                    <div className="input_field flex flex-col items-start flex-1">
                      <div className="input_with_label flex flex-col items-start self-stretch">
                        <div className="label_wrapper flex items-start">
                          <div className="text-[#414651] font-medium">
                            Country
                          </div>
                          <div className="text-[#009c97] font-medium">*</div>
                        </div>
                        <div className="text-gray-700 input flex items-center self-stretch py-2 px-3 rounded-lg border border-[#d5d7da] bg-white">
                          <input
                            type="text"
                            name="country"
                            placeholder="Enter country"
                            value={formData.country}
                            onChange={handleInputChange}
                            className="text-gray-700 w-full outline-none"
                          />
                        </div>
                        {errors.country && <span className="text-red-500 text-sm">{errors.country}</span>}
                      </div>
                    </div>
                    
                    <div className="input_field-3 flex flex-col items-start flex-1">
                      <div className="input_with_label-4 flex flex-col items-start self-stretch">
                        <div className="label_wrapper-3 flex items-start">
                          <div className="text-[#414651] font-medium">
                            Experience Level
                          </div>
                          <div className="text-[#009c97] font-medium">*</div>
                        </div>
                        <div className="input-4 flex items-start self-stretch rounded-lg border border-[#d5d7da] bg-white">
                          <div className="text-gray-700 content-23 flex items-center py-2 pl-3 w-full">
                            <select 
                              name="level"
                              value={formData.level}
                              onChange={handleInputChange}
                              className="w-full mr-3 outline-none"
                            >
                              <option value="">Choose an experience level</option>
                              <option value="Entry Level">Entry Level</option>
                              <option value="Mid Level">Mid Level</option>
                              <option value="Senior Level">Senior Level</option>
                              <option value="Executive">Executive</option>
                            </select>
                          </div>
                        </div>
                        {errors.level && <span className="text-red-500 text-sm">{errors.level}</span>}
                      </div>
                    </div>
                  </div>

                  {/* Fifth Row - Employment Type and Job Status */}
                  <div className="flex items-center gap-6 self-stretch">
                    <div className="input_field-4 flex flex-col items-start flex-1">
                      <div className="input_with_label-5 flex flex-col items-start self-stretch">
                        <div className="label_wrapper-4 flex items-start">
                          <div className="text-[#414651] font-medium">
                            Employment Type
                          </div>
                          <div className="text-[#009c97] font-medium">*</div>
                        </div>
                        <div className="input-5 flex items-start self-stretch rounded-lg border border-[#d5d7da] bg-white">
                          <div className="text-gray-700 content-24 flex items-center py-2 pl-3 w-full">
                            <select 
                              name="type"
                              value={formData.type}
                              onChange={handleInputChange}
                              className="w-full mr-3 outline-none"
                            >
                              <option value="">Choose employment type</option>
                              <option value="Full-time">Full-time</option>
                              <option value="Part-time">Part-time</option>
                              <option value="Contract">Contract</option>
                              <option value="Freelance">Freelance</option>
                              <option value="Internship">Internship</option>
                            </select>
                          </div>
                        </div>
                        {errors.type && <span className="text-red-500 text-sm">{errors.type}</span>}
                      </div>
                    </div>
                    
                    <div className="input_field-5 flex flex-col items-start flex-1">
                      <div className="input_with_label-6 flex flex-col items-start self-stretch">
                        <div className="label_wrapper-5 flex items-start">
                          <div className="text-[#414651] font-medium">
                            Job Status
                          </div>
                          <div className="text-[#009c97] font-medium">*</div>
                        </div>
                        <div className="input-6 flex items-start self-stretch rounded-lg border border-[#d5d7da] bg-white">
                          <div className="text-gray-700 content-25 flex items-center py-2 pl-3 w-full">
                            <select 
                              name="position"
                              value={formData.position}
                              onChange={handleInputChange}
                              className="w-full mr-3 outline-none"
                            >
                              <option value="">Choose job status</option>
                              <option value="Open">Open</option>
                              <option value="Closed">Closed</option>
                              <option value="Draft">Draft</option>
                              <option value="On Hold">On Hold</option>
                            </select>
                          </div>
                        </div>
                        {errors.position && <span className="text-red-500 text-sm">{errors.position}</span>}
                      </div>
                    </div>
                  </div>

                  {/* Sixth Row - Company and Salary Period */}
                  <div className="flex items-center gap-6 self-stretch">
                    <div className="input_field flex flex-col items-start flex-1">
                      <div className="input_with_label flex flex-col items-start self-stretch">
                        <div className="label_wrapper flex items-start">
                          <div className="text-[#414651] font-medium">
                            Company
                          </div>
                        </div>
                        <div className="input flex items-center self-stretch py-2 px-3 rounded-lg border border-[#d5d7da] bg-white">
                          <input
                            type="text"
                            name="company"
                            placeholder="Enter company name"
                            value={formData.company}
                            onChange={handleInputChange}
                            className="text-gray-700 w-full outline-none"
                          />
                        </div>
                      </div>
                    </div>
                    
                    <div className="input_field flex flex-col items-start flex-1">
                      <div className="input_with_label flex flex-col items-start self-stretch">
                        <div className="label_wrapper flex items-start">
                          <div className="text-[#414651] font-medium">
                            Salary Period
                          </div>
                        </div>
                        <div className="input flex items-start self-stretch rounded-lg border border-[#d5d7da] bg-white">
                          <div className="text-gray-700 content flex items-center py-2 px-3 w-full">
                            <select
                              name="salary_period_library"
                              value={formData.salary_period_library}
                              onChange={handleInputChange}
                              className="w-full mr-3 outline-none"
                            >
                              <option value="">Choose salary period</option>
                              {salaryPeriods.map(period => (
                                <option key={period.value} value={period.value}>{period.label}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Library Fields Display Section */}
                  <div className="flex flex-col items-start gap-4 self-stretch bg-gray-50 p-4 rounded-lg">
                    <div className="text-[#414651] font-medium">
                      Library Mappings (Auto-populated)
                    </div>
                    <div className="grid grid-cols-2 gap-4 w-full">
                      <div className="text-sm">
                        <span className="text-gray-600">Employment Type Library:</span>
                        <span className="ml-2 text-gray-800">{formData.employment_type_library || 'Not set'}</span>
                      </div>
                      <div className="text-sm">
                        <span className="text-gray-600">Industry Library:</span>
                        <span className="ml-2 text-gray-800">{formData.industry_library || 'Not set'}</span>
                      </div>
                      <div className="text-sm">
                        <span className="text-gray-600">Region Library:</span>
                        <span className="ml-2 text-gray-800">{formData.region_library || 'Not set'}</span>
                      </div>
                      <div className="text-sm">
                        <span className="text-gray-600">Salary Period Library:</span>
                        <span className="ml-2 text-gray-800">{formData.salary_period_library || 'Not set'}</span>
                      </div>
                    </div>
                  </div>



                  {/* Error Display */}
                  {errors.submit && (
                    <div className="text-red-500 text-sm">{errors.submit}</div>
                  )}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="actions-1 flex justify-end items-center self-stretch gap-4">
                <button 
                  type="button"
                  className="border border-gray-300 rounded-lg text-gray-700 cursor-pointer px-4 py-2"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`rounded-lg text-white cursor-pointer px-4 py-2 ${
                    isSubmitting ? 'bg-gray-400' : 'bg-[#19bfb7] hover:bg-[#16a8a1]'
                  }`}
                >
                  {isSubmitting ? 'Creating...' : 'Create Job'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateJob;